import React from "react";

// reactstrap components

// core components
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import IndexHeader from "components/Headers/IndexHeader.js";
import DemoFooter from "components/Footers/DemoFooter.js";
import Logo from "components/Headers/Logo.js"
import LearnMore from "components/sections/LearnMore";
import Boost from "components/sections/Boost";
import SweepHeader from "components/Headers/SweepHeader";
import Count from "components/sections/Count";
import Questions from "components/sections/Questions";
// here you import


// index sections

import SectionButtons from "views/index-sections/SectionButtons.js";
import SectionNavbars from "views/index-sections/SectionNavbars.js";
import SectionNavigation from "views/index-sections/SectionNavigation.js";
import SectionProgress from "views/index-sections/SectionProgress.js";
import SectionNotifications from "views/index-sections/SectionNotifications.js";
import SectionTypography from "views/index-sections/SectionTypography.js";
import SectionJavaScript from "views/index-sections/SectionJavaScript.js";
import SectionCarousel from "views/index-sections/SectionCarousel.js";
import SectionNucleoIcons from "views/index-sections/SectionNucleoIcons.js";
import SectionDark from "views/index-sections/SectionDark.js";
import SectionLogin from "views/index-sections/SectionLogin.js";
import SectionExamples from "views/index-sections/SectionExamples.js";
import SectionDownload from "views/index-sections/SectionDownload.js";
import BusinessHeader from "components/Headers/BusinessHeader";
import Build from "components/sections/Build";
import Account from "components/sections/Account";
import Steps from "components/sections/Steps";
import Primary from "components/sections/Primary";
import Options from "components/sections/Options";
import SupportHeader from "components/Headers/SupportHeader";
import Support from "components/sections/Support";
import FAQHeader from "components/Headers/FAQHeader"; 
import Tips from "components/sections/Tips";
import Frequent from "components/sections/Frequent";
import Footer from "components/sections/Footer";
function FAQ() {
  React.useEffect(() => {
    document.body.classList.add("index");
    // Adding padding-top to the body
    // document.body.style.paddingTop = "250px";
    return function cleanup() {
      document.body.classList.remove("index");
      // Resetting padding-top when component unmounts
      document.body.style.paddingTop = null;
    };
    }, []); // Empty dependency array to ensure effect only runs once

  return (
    <> 

      <IndexNavbar />
      <FAQHeader />
      <div className="main">
      <Tips />
      <Frequent/>
      <Footer/>

      

      </div>
    </>
  );
}

export default FAQ;